export const availableLanguages = {
    bg: { code: 'bg', label: 'BG', flag: '🇧🇬', displayName: 'Български' },
    de: { code: 'de', label: 'DE', flag: '🇩🇪', displayName: 'Deutsch' },
    en: { code: 'en', label: 'EN', flag: '🇬🇧', displayName: 'English' },
    es: { code: 'es', label: 'ES', flag: '🇪🇸', displayName: 'Español' },
    fr: { code: 'fr', label: 'FR', flag: '🇫🇷', displayName: 'Français' },
    it: { code: 'it', label: 'IT', flag: '🇮🇹', displayName: 'Italiano' },
    pt: { code: 'pt', label: 'PT', flag: '🇵🇹', displayName: 'Português' },
    ro: { code: 'ro', label: 'RO', flag: '🇷🇴', displayName: 'Română' },
    tr: { code: 'tr', label: 'TR', flag: '🇹🇷', displayName: 'Türkçe' },
    mt: { code: 'mt', label: 'MT', flag: '🇲🇹', displayName: 'Malti' },
    el: { code: 'el', label: 'EL', flag: '🇬🇷', displayName: 'Ελληνικά' }
};